export const ACCESS_TOKEN = 'access_token';
export const DEFAULT_AUTH_ENDPOINT = '/authorize';
export const DEFAULT_AUTH_LOGOUT_ENDPOINT = '/connect/endSession';
export const DEFAULT_AUTH_TOKEN_ENDPOINT = '/access_token';
export const ID_TOKEN = 'id_token';
export const REFRESH_TOKEN = 'refresh_token';
export const SUBJECT_OF_TOKEN = 'sub';
export const TRANSACTION_KEY = 'auth.spajs.txs';
